module.exports = __webpack_public_path__ + "static/media/k-dot.9362a85b.svg";